<template>
  <div class="p-grid p-pb-6">
    <div class="p-col-12 p-pt-1 p-pb-1">
      <h2><a href="#/account">{{ $t('userinfo.title_parent') }}</a> <img class="p-pl-2 p-pr-2"
          src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')" /> {{ $t('orders.title') }}
      </h2>
      <div class="irinox-form">

          <DataTable v-if="orders?.length > 0" :value="orders" stripedRows
              responsiveLayout="stack"
              breakpoint="960px"
              :autoLayout="true" class="after-sales-table-full p-mt-4"
              sortField="insertDate" :sortOrder="-1"
              selectionMode="single" dataKey="id" @row-click="rowClick"
              >
              <!-- v-model:filters="filters" :globalFilterFields="['code', 'descIt', 'descEn', 'descEs', 'descFr', 'descDe', 'descRu']" -->

              <Column field="id" :header="$t('orders.col_id')" ></Column>

              <Column field="items" :header="$t('orders.col_spareparts')">
                <template #body="slotProps">
                  <div v-for="item in slotProps.data.items" :key="item.code">
                    {{ item.code }} (x{{ item.quantity }})
                  </div>
                </template>
              </Column>
              
              <Column field="totalPrice" :header="$t('orders.col_totalPrice')">
                <template #body="slotProps">
                  {{ slotProps.data.totalPrice ? $n(slotProps.data.totalPrice, 'money') : '-' }}
                  {{ slotProps.data.totalPrice ? (slotProps.data.currency === 'EUR' ? '€ ' : '$ ') : '' }}
                </template>
              </Column>
              
              <Column field="insertDate" :header="$t('orders.col_insertDate')">
                <template #body="slotProps">
                  {{ $d(new Date(slotProps.data.insertDate), is24hour ? 'long' : 'long12') }}
                </template>
              </Column>

              <Column>
                <template #body="slotProps">
                  <div class="p-text-right">
                    <Button :label="$t('orders.buy_again')" class="p-button-outlined" @click="buyAgain(slotProps.data)"/>
                  </div>
                </template>
              </Column>

          </DataTable>

          <div v-else class="empty-list">
            {{ $t('orders.empty_list') }}
          </div>


      </div>
    </div>
  </div>

  <OrderDetails v-model:visible="dialog.orderDetails" :order="selectedOrder" @cart:put="addToCart"/>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('spareParts.cart.error_dialog')" :life="5000"
    @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('spareParts.preorder_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import AfterSalesService from '../../../service/AfterSalesService';
import OrderDetails from './OrderDetails.vue';

export default {
  components: {
    IrinoxDialogDark,
    OrderDetails
  },
  data() {
    return {
      orders: [],
      dialog: {
        orderDetails: false,
        success: false,
        error: false
      },
      selectedOrder: null
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      role: 'userdata/role',
      cart: 'afterSales/cart',
      is24hour: 'userdata/is24hour'
    }),
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
    this.reloadOrders();
  },
  methods: {
    reloadOrders() {
      this.afterSalesService.getSpOrders(this.personaltoken)
        .then((data) => {
          if (data.code === "200") {
            this.orders = data.body;
          } else {
            console.error("ERROR " + JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.dialog.error = true;
        });
    },
    async buyAgain(order) {
      console.log("By again order ", order);
      for(let item of order.items) {
        if(!await this.addToCart(item.code, item.quantity)) {
          this.dialog.error = true;
          return;
        }
      }
      this.dialog.success = true;
    },
    rowClick(event) {
      this.selectedOrder = event.data;
      this.dialog.orderDetails = true;
    },
    async addToCart(code, quantity, singleItem = false) {
      console.log("Add to cart ", code, quantity);
      let data = await this.afterSalesService.putSpCart(this.personaltoken, code, quantity, null);

      if (data.code == "200") {
        if(singleItem) {
          this.dialog.success = true;
        }
        this.$store.commit('afterSales/cart', data.body);
        return true;
      }
      if(singleItem) {
          this.dialog.error = true;
        }
      return false;
    }
  }
}
</script>

<style scoped>
</style>